import { ObjectIdentityTitle } from "../ObjectIdentityTitle";
import { withTimeSystem } from "../../constants/orbitMetadata";
import { formatDate } from "./eventEvolutionUtils";

interface EventObjectTitleProps {
  cospar?: string;
  name?: string;
  norad?: string;
  sourceOfInformation?: string;
  updateTime?: string;
}

export const EventObjectTitle = ({
  cospar,
  name,
  norad,
  sourceOfInformation,
  updateTime,
}: EventObjectTitleProps) => (
  <ObjectIdentityTitle
    cospar={cospar}
    linkToObject
    meta={`${
      sourceOfInformation ? `${sourceOfInformation} | ` : ""
    }${withTimeSystem("Update Time")}: ${formatDate(updateTime)}`}
    metaTitle={updateTime}
    name={name}
    norad={norad}
  />
);
